import { IPackageListingState, IEventFilter, defaultPackageListingModel, PackageType, ISfoCartItem, AlternateCartItemType, IAlternateCartItem, IBaseSfoCartItem } from '../../classes/package-listing';
import { IProduction, IPerformanceGroup, IPackage, IPerformancePricing, IPerformance } from '../../custom/classes/production';

import { ActionType, IPackageListingStateAction } from '../../classes/package-listing-actions';

import { filterMap } from '../../helpers/map-helpers';

import { cloneDeep } from 'lodash';
import cartItem from '../../components/cart/cart-item';
import { disablePerformanceButtons } from '../actions/package-listing.actions';
/**
 * This where all of the application logic resides.
 */
export default function packageListingReducer(state: IPackageListingState<IPackage> = defaultPackageListingModel, action: IPackageListingStateAction) {
    switch (action.type) {
        case ActionType.LoadPackage: {
            return { ...state, packageDetail: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.LoadPackages: {
            return { ...state, packages: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePerformancesFilter: {
            const updating = true;
            const addedFilterFunction = action.value;

            var eventFilter: IEventFilter[] = null;
            if (state.eventFilter.some(filter => { return filter.key === addedFilterFunction.key })) {
                eventFilter = state.eventFilter.filter(filter => !(filter.key === addedFilterFunction.key)).concat([addedFilterFunction]);
            } else {
                eventFilter = state.eventFilter.concat([addedFilterFunction])
            }
            const filterFunction = (event) => eventFilter.map(fil => {
                return fil.filter;
            }).every(f => f(event));

            return { ...state, eventFilter, filterFunction, updating } as IPackageListingState<IPackage>;
        }
        case ActionType.RemovePerformancesFilter: {
            const eventFilter = state.eventFilter.filter(filter => filter.key !== action.value);
            const filterFunction = (event: IProduction) => eventFilter.map(filter => filter.filter).every(func => func(event));

            return { ...state, eventFilter, filterFunction, updating: true } as IPackageListingState<IPackage>;
        }
        case ActionType.RemoveAllPerformancesFilters: {
            return { ...state, eventFilter: [], filterFunction: (event: IProduction) => true, updating: true } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdateOrderNotes: {
            return { ...state, orderNotes: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.AddItemToCart: {
            const isFixedAndUnseated = action.value.isFixed && (action.value.unseated ?? true);
            const currentFixedPackageItemInNeedOfSecondChoice = isFixedAndUnseated
                ? state.cartItems.filter(item =>
                    (item.selectedAlternateItem?.type === AlternateCartItemType.PACKAGE
                    || item.selectedAlternateItem === null)
                    && !item.selectedAlternateItem?.cartItemId
                )[0]
                : null;

            const updatedCartItem: ISfoCartItem = currentFixedPackageItemInNeedOfSecondChoice
                ? {
                    ...currentFixedPackageItemInNeedOfSecondChoice,
                    selectedAlternateItem: {
                        type: AlternateCartItemType.PACKAGE,
                        cartItemId: action.value.itemId,
                        selectedZoneId: 0
                    }
                }
                : {
                    cartItemId: action.value.itemId,
                    selectedZoneId: 0,
                    selectedAlternateItem: null
                };

            let updatedSubPackageMap;
            if (action.value.packageId) {
                const addedSubPackages = state.subPackagesInCart.get(action.value.packageId);
                let updatedSubPackageList = [...action.value.itemId];

                if (addedSubPackages) {
                    updatedSubPackageList = addedSubPackages.concat(updatedSubPackageList);
                }

                updatedSubPackageMap = state.subPackagesInCart.set(action.value.packageId, updatedSubPackageList)
            }

            return {
                ...state,
                cartItems: state.cartItems
                    .filter(item => item !== action.value.itemId && item !== currentFixedPackageItemInNeedOfSecondChoice)
                    .concat(Array(1).fill(updatedCartItem)),
                subPackagesInCart: updatedSubPackageMap
                    ? updatedSubPackageMap
                    : state.subPackagesInCart
            } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdateSeatingPreferences: {
            return { ...state, seatingPreferences: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.RemoveItemFromCart: {
            const matchedSuperPackage = state.subPackagesInCart.get(action.value.itemId);
            if (matchedSuperPackage) {
                const newPerfs = state.cartItems.filter(cartItem => matchedSuperPackage.indexOf(cartItem.cartItemId) < 0);
                const newSubPackageList = filterMap(state.subPackagesInCart, cartItem => cartItem !== action.value.itemId)
                return { ...state, cartItems: newPerfs, subPackagesInCart: newSubPackageList } as IPackageListingState<IPackage>;
            }

            const removeAlternateItem = action.value.isAlternate;
            return {
                ...state,
                cartItems: removeAlternateItem
                    ? state.cartItems.map(item => item.cartItemId === action.value.itemId
                        ? {
                            ...item,
                            selectedAlternateItem: {
                                type: AlternateCartItemType.PACKAGE,
                                cartItemId: 0,
                                selectedZoneId: 0
                            }
                        }
                        : item
                    )
                    : state.cartItems.filter(item => item.cartItemId !== action.value.itemId)
            } as IPackageListingState<IPackage>;
        }
        case ActionType.PerformancesUpdated: {
            return { ...state, updating: false } as IPackageListingState<IPackage>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            return state as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePriceTypeQuantity: {
            state.priceTypeQuantity.set(action.value.priceTypeId, action.value.quantity);
            const ticketSum = Array.from(state.priceTypeQuantity.values()).reduce((total, num) => total + num, 0);
            return { ...state, totalNumberOfTicket: ticketSum } as IPackageListingState<IPackage>;
        }

        case ActionType.ClearPriceTypeQuantities: {
            state.priceTypeQuantity.clear();
            var defaultNumberOfTickets = 0;

            if (state.packageDetail != null && state.packageDetail.packagePriceTypes.length == 1) {
                defaultNumberOfTickets = 1;
                state.priceTypeQuantity.set(state.packageDetail.packagePriceTypes[0].priceTypeId, 1);
            }

            return { ...state, totalNumberOfTicket: defaultNumberOfTickets, priceTypeQuantity: new Map<number, number>() } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessing: {
            return { ...state, processing: true, errorMessages: [] } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessingErrors: {
            return { ...state, processing: false, errorMessages: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.ReceivePerformancePricing: {
            const perfPricing: IPerformancePricing = action.value;

            var newList = state.performancePricingList.set(perfPricing.performanceId, perfPricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }

        case ActionType.ReceivePackagePricing: {
            const packagePricing = action.value;

            var newList = state.performancePricingList.set(packagePricing.packageId, packagePricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }
        case ActionType.UpdateSelectedZone: {
            const { itemId, zoneId, isSecondChoice } = action.value;

            const isUpdateForAnAlternatePackageZoneSelection = (pkg) =>
                isSecondChoice && pkg.selectedAlternateItem.type === AlternateCartItemType.PACKAGE;

            const matchedCartItem: ISfoCartItem = state.cartItems
                .filter(pkg => isUpdateForAnAlternatePackageZoneSelection(pkg)
                    ? pkg.selectedAlternateItem.cartItemId === itemId
                    : pkg.cartItemId == itemId)[0]
                ?? {
                    cartItemId: itemId,
                    selectedZoneId: zoneId,
                    selectedAlternateItem: null
                };

            if (isSecondChoice) {
                matchedCartItem.selectedAlternateItem = {
                    ...matchedCartItem.selectedAlternateItem,
                    selectedZoneId: zoneId
                }
            } else {
                matchedCartItem.selectedZoneId = zoneId;
            }

            return {
                ...state,
                cartItems: state.cartItems
                    .filter(p => p !== matchedCartItem)
                    .concat(Array(1).fill(matchedCartItem))
            } as IPackageListingState<IPackage>;
        }
        case ActionType.RemoveSelectedZone: {
            const updatedZone = { cartItemId: action.value, selectedZoneId: 0, selectedSecondChoiceZoneId: 0 };

            return {
                ...state, cartItems: state.cartItems.filter(p => p !== action.value)
                    .concat(Array(1).fill(updatedZone))
            } as IPackageListingState<IPackage>;

        }

        //case ActionType.UpdatePackageZone: {

        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, action.value.zoneId) } as IPackageListingState<IPackage>;

        //}

        //case ActionType.RemovePackageZone: {
        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, 0) } as IPackageListingState<IPackage>;

        //}

        case ActionType.ToggleMiniCart: {
            return { ...state, miniCartOpen: action.value } as IPackageListingState<IPackage>;

        }
        case ActionType.SetSpecialFeatureMap: {
            return { ...state, specialFeatureMap: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.ToggleAlternateRequestType: {
            return {
                ...state,
                cartItems: state.cartItems.map((cartItem) => {
                    if (cartItem.cartItemId !== action.value) {
                        return cartItem;
                    }

                    const toggledCartItem: ISfoCartItem = {
                        ...cartItem,
                        selectedAlternateItem: {
                            type: cartItem.selectedAlternateItem?.type === AlternateCartItemType.ZONE
                                ? AlternateCartItemType.PACKAGE
                                : AlternateCartItemType.ZONE,
                            cartItemId: 0,
                            selectedZoneId: 0
                        }
                    }
                    return toggledCartItem;
                })
            }
        }
        case ActionType.DisablePerformanceButtons: {
            return { ...state, disableAllSeriesButtons: action.value } as IPackageListingState<IPackage>;
        }
        default:
            return state;
    }
}
